import { GetCreditCardResultsPage } from 'queries/creditCardResultsPage.gql';
import { GetCreditCards } from 'queries/creditCards.gql';
import { GetCreditCardApplicationPage } from 'queries/getCreditCardApplicationPage.gql';
import { GetPersonalAccidentInsuranceApplicationPage } from 'queries/GetPersonalAccidentInsuranceApplicationPage.gql';
import { PutCreditCardApplicationPage } from 'queries/putCreditCardApplicationPage.gql';
import { GetPersonalLoanApplicationPage } from 'queries/getPersonalLoanApplicationPage.gql';
import { GetDbsPersonalLoanApplicationPage } from 'queries/getDbsPersonalLoanApplicationPage.gql';
import { GetDbsPlInstallmentAmount } from 'queries/getDbsPlInstallmentAmount.gql';
import { PutPersonalLoanApplication } from 'queries/putPersonalLoanApplication.gql';
import { PutPersonalLoanApplicationDbs } from 'queries/putPersonalLoanApplicationDbs.gql';
import { PutPersonalAccidentApplication } from 'queries/putPersonalAccidentApplication.gql';
import { PutOnlineBankingInsuranceApplication } from 'queries/putOnlineBankingInsuranceApplication.gql';
import { PutCustomerLeadApplication } from 'queries/putCustomerLeadApplication.gql';
import { GetPersonalLoanResultsPage } from 'queries/personalLoanResultsPage.gql';
import { GetPersonalLoans } from 'queries/personalLoans.gql';
import { GetApplicationBasicStaticConfig } from 'queries/getApplicationBasicStaticConfig.gql';
import { GetDbsPlApplicationStatusPage } from 'queries/getDbsPlApplicationStatusPage.gql';
import { GetProviderAvailabilityStatus } from 'queries/getProviderAvailabilityStatus.gql';
import { GetTravelInsuranceResultsPage } from 'queries/travelInsuranceResultsPage.gql';
import { GetTravelInsurances } from 'queries/travelInsurances.gql';
import { GetProvider } from 'queries/provider.gql';
import { GetSecuritiesAccountsResultPage } from 'queries/securitiesAccountsResultPage.gql';
import { GetSecuritiesAccounts } from 'queries/securitiesAccounts.gql';
import { GetBankAccountsResultPage } from 'queries/bankAccountsResultPage.gql';
import { GetBankAccounts } from 'queries/bankAccounts.gql';
import { GetInvestmentPlansResultPage } from 'queries/investmentPlansResultPage.gql';
import { GetInvestmentPlans } from 'queries/investmentPlans.gql';
import { GetMortgageResultsPage } from 'queries/mortgageResultsPage.gql';
import { GetMortgages } from 'queries/mortgages.gql';
import { GetTravelInsuranceApplicationPage } from 'queries/getTravelInsuranceApplicationPage.gql';
import { GetTravelInsurancePrice } from 'queries/getTravelInsurancePrice.gql';
import { PutTravelInsuranceApplication } from 'queries/putTravelInsuranceApplication.gql';
import { GetHomeInsurances } from 'queries/homeInsurances.gql';
import { GetHomeInsurancesResultPage } from 'queries/homeInsurancesResultPage.gql';
import { GetTravelInsuranceFunnelPage } from 'queries/travelInsuranceFunnelPage.gql';
import { GetDomesticHelperInsuranceResultPage } from 'queries/domesticHelperInsuranceResultPage.gql';
import { GetDomesticHelperInsurances } from 'queries/domesticHelperInsurance.gql';
import { GetStaticPage } from 'queries/staticPage.gql';
import { GetTITnc } from 'queries/getTITnc.gql';
import { GetMortgageFunnelPage } from 'queries/mortgageFunnelPage.gql';
import { GetMortgageApplicationPage } from 'queries/getMortgageApplicationPage.gql';
import { PutMortgageApplication } from 'queries/putMortgageApplication.gql';
import { GetProviderResultsPage } from 'queries/providerResultsPage.gql';
import { GetApplicationSuccessPage } from 'queries/getApplicationSuccessPage.gql';
import { GetVerticalQuery } from 'queries/verticalQuery.gql';
import { GetNewsletterUnsubscribePage } from 'queries/GetNewsletterUnsubscribePage.gql';
import { StopNewsletterSubscription } from 'queries/stopNewsletterSubscription.gql';
import { GetTIApplicationSuccessPage } from 'queries/getTIApplicationSuccessPage.gql';
import { GetPAApplicationSuccessPage } from 'queries/getPAApplicationSuccessPage.gql';
import { GetMyInfoPage } from 'queries/getMyInfoPage.gql';
import { GetApplicationToken } from 'queries/GetApplicationToken.gql';
import { GetApplicationTokenSeeded } from 'queries/GetApplicationTokenSeeded.gql';
import { GetAffiliateWidget } from 'queries/affiliateWidget.gql';
import { GetForgotPasswordPage } from 'queries/GetForgotPasswordPage.gql';
import { GetRedeemRewardPage } from 'queries/GetRedeemRewardPage.gql';
import { GetRewardAlreadySubmittedPage } from 'queries/GetRewardAlreadySubmittedPage.gql';
import { CreateAccount } from 'queries/auth/createAccount.gql';
import { Login } from 'queries/auth/login.gql';
import { mfaRegistration } from 'queries/auth/mfaRegistration.gql';
import { mfaEmailRegistration } from 'queries/auth/mfaEmailRegistration.gql';
import { emailRegistration } from 'queries/auth/emailRegistration.gql';
import { mfaVerification } from 'queries/auth/mfaVerification.gql';
import { mfaResend } from 'queries/auth/mfaResend.gql';
import { mfaActivation } from 'queries/auth/mfaActivation.gql';
import { requestPasswordReset } from 'queries/auth/requestPasswordReset.gql';
import { GetDashboardProfile } from 'queries/GetDashboardProfile.gql';
import { continuePasswordReset } from 'queries/auth/continuePasswordReset.gql';
import { setNewPassword } from 'queries/auth/setNewPassword.gql';
import { GetDashboardPage } from 'queries/getDashboardPage.gql';
import { GetLoginPage } from 'queries/getLoginPage.gql';
import { GetDashboardSettingsPage } from 'queries/getDashboardSettingsPage.gql';
import { GetCustomerProducts } from 'queries/getCustomerProducts.gql';
import { GetCustomerRewards } from 'queries/getCustomerRewards.gql';
import { GetRewardRegisterForm } from 'queries/GetRewardRegisterForm.gql';
import { GetDashboardMoreInfoTI } from 'queries/GetDashboardMoreInfoTI.gql';
import { logout } from 'queries/auth/logout.gql';
import { registerReward } from 'queries/registerReward.gql';
import { redeemReward } from 'queries/redeemReward.gql';
import { updateCustomer } from 'queries/updateCustomer.gql';
import { TravelInsuranceAutoFill } from 'queries/TravelInsuranceAutoFill.gql';
import { processDowntime } from 'queries/processDowntime.gql';
import { GetProduct } from 'queries/GetProduct.gql';
import { redeemSubmission } from 'queries/auth/redeemSubmission.gql';
import { GetPaymentPage } from 'queries/GetPaymentPage.gql';
import { GetDashboardMoreInfoReward } from 'queries/GetDashboardMoreInfoReward.gql';
import { GetDashboardMoreInfoPA } from 'queries/GetDashboardMoreInfoPA.gql';
import { AddNewsletterSubscription } from 'queries/newsletterSubscription.gql';
import { GetDashboardMoreInfoOB } from 'queries/GetDashboardMoreInfoOB.gql';
import { GetOnlineBankingInsuranceApplicationPage } from 'queries/getOnlineBankingInsuranceApplicationPage.gql';
import { GetLoginLandingPage } from 'queries/GetLoginLandingPage.gql';
import { GetAutoFill } from 'queries/getAutoFill.gql';
import { submitQuiz } from 'queries/submitQuiz.gql';
import { GetErrorPage } from 'queries/errorPage.gql';
import { GetLandingPage } from 'queries/GetLandingPage.gql';

const Queries = {
  AddNewsletterSubscription,
  continuePasswordReset,
  CreateAccount,
  emailRegistration,
  GetAffiliateWidget,
  GetApplicationBasicStaticConfig,
  GetApplicationSuccessPage,
  GetApplicationToken,
  GetApplicationTokenSeeded,
  GetBankAccounts,
  GetBankAccountsResultPage,
  GetInvestmentPlans,
  GetInvestmentPlansResultPage,
  GetCreditCardApplicationPage,
  GetPersonalAccidentInsuranceApplicationPage,
  GetCreditCardResultsPage,
  GetCreditCards,
  GetCustomerProducts,
  GetCustomerRewards,
  GetDashboardMoreInfoReward,
  GetDashboardMoreInfoTI,
  GetDashboardPage,
  GetLoginPage,
  GetLoginLandingPage,
  GetDashboardProfile,
  GetDashboardSettingsPage,
  GetDbsPersonalLoanApplicationPage,
  GetDbsPlApplicationStatusPage,
  GetDbsPlInstallmentAmount,
  GetDomesticHelperInsuranceResultPage,
  GetDomesticHelperInsurances,
  GetLandingPage,
  GetForgotPasswordPage,
  GetHomeInsurances,
  GetHomeInsurancesResultPage,
  GetMortgageApplicationPage,
  GetMortgageFunnelPage,
  GetMortgageResultsPage,
  GetMortgages,
  GetMyInfoPage,
  GetNewsletterUnsubscribePage,
  GetPaymentPage,
  GetPersonalLoanApplicationPage,
  GetPersonalLoanResultsPage,
  GetPersonalLoans,
  GetProduct,
  GetProvider,
  GetProviderAvailabilityStatus,
  GetProviderResultsPage,
  GetRewardRegisterForm,
  GetSecuritiesAccounts,
  GetSecuritiesAccountsResultPage,
  GetStaticPage,
  GetTIApplicationSuccessPage,
  GetPAApplicationSuccessPage,
  GetTITnc,
  GetTravelInsuranceApplicationPage,
  GetTravelInsuranceFunnelPage,
  GetTravelInsurancePrice,
  GetTravelInsuranceResultsPage,
  GetTravelInsurances,
  GetVerticalQuery,
  GetRedeemRewardPage,
  GetRewardAlreadySubmittedPage,
  Login,
  logout,
  mfaActivation,
  mfaRegistration,
  mfaEmailRegistration,
  mfaResend,
  mfaVerification,
  processDowntime,
  PutCreditCardApplicationPage,
  PutCustomerLeadApplication,
  PutMortgageApplication,
  PutPersonalLoanApplication,
  PutPersonalLoanApplicationDbs,
  PutPersonalAccidentApplication,
  PutOnlineBankingInsuranceApplication,
  PutTravelInsuranceApplication,
  redeemSubmission,
  requestPasswordReset,
  setNewPassword,
  StopNewsletterSubscription,
  registerReward,
  redeemReward,
  updateCustomer,
  TravelInsuranceAutoFill,
  GetDashboardMoreInfoPA,
  GetDashboardMoreInfoOB,
  GetOnlineBankingInsuranceApplicationPage,
  GetAutoFill,
  submitQuiz,
  GetErrorPage,
};

export default Queries;
